export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-background border-t border-border py-16 px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-6">
          <h3 className="text-3xl font-light text-foreground">
            Carbon Pages
          </h3>
          <p className="text-sm text-muted-foreground max-w-md mx-auto">
            Three Plays from Daniel Gavilovsky; including COGNITOHAZARD, No Weapon Formed Against You, and Bored and Broke in Buenos Aires.
            <br />
            Available in paperback and hardcover.
          </p>
          <div className="flex justify-center space-x-6 text-sm">
            <a
              href={process.env.REACT_APP_PURCHASE_URL || "https://www.amazon.com"}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors"
            >
              Amazon
            </a>
            <span className="text-border">|</span>
            <a
              href="mailto:contact@carbonpages.com"
              className="text-foreground/70 hover:text-primary transition-colors"
            >
              Follow Us
            </a>
          </div>
          <div className="pt-8 border-t border-border/50">
            <p className="text-xs text-muted-foreground">
              © {currentYear} Carbon Pages. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground/70 italic mt-2">
              A printed object in a digital world
            </p>
          </div>
        </div>
      </div>
      
      {/* August 15, 1998 date display with Bondi blue accent */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
        <p className="text-sm font-mono tracking-wider" style={{ color: 'hsl(var(--bondi-blue))' }}>
          August 15, 1998
        </p>
      </div>
    </footer>
  );
};